import { render, staticRenderFns } from "./AgentNotifications.vue?vue&type=template&id=d7649376&scoped=true"
import script from "./AgentNotifications.vue?vue&type=script&lang=ts"
export * from "./AgentNotifications.vue?vue&type=script&lang=ts"
import style0 from "./AgentNotifications.vue?vue&type=style&index=0&id=d7649376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7649376",
  null
  
)

export default component.exports